/**
 * Nass Video Autoplay Unlock — global, loaded from layout/theme.liquid.
 *
 * iOS/WebKit blocks video autoplay in Low Power Mode (yellow battery) OS-wide,
 * even for muted + playsinline video — the `autoplay` attribute and JS play()
 * both no-op until the user interacts. A user GESTURE is still allowed to start
 * playback, so on the first tap/click/keypress we (re)start any declared
 * autoplay video that's currently on screen and paused. After that first
 * interaction iOS keeps letting muted videos play, so the rest start as the
 * visitor scrolls.
 *
 * Scope: only videos that are MEANT to autoplay — `video[autoplay]` (incl.
 * Shopify video_tag autoplay output) and `video[data-nass-lazy-video]`. Videos
 * with no resolvable source (e.g. Horizon's lazy <video-background-component>,
 * which fills src later) are skipped so we never fight another controller.
 * At full battery nothing changes — native autoplay already runs.
 */
(function () {
  function hasSource(v) {
    return !!(v.currentSrc || v.getAttribute('src') || v.querySelector('source[src]'));
  }

  function unlock() {
    var vids = document.querySelectorAll('video[autoplay], video[data-nass-lazy-video]');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (!v.paused || !hasSource(v)) continue;
      var r = v.getBoundingClientRect();
      var inView = r.bottom > -120 && r.top < (window.innerHeight || 0) + 320;
      if (!inView) continue;
      v.muted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  // Kept persistent (not {once}) so playback keeps catching up as the visitor
  // taps/scrolls through the page in Low Power Mode. Cheap: it only ever calls
  // play() on paused, in-view, autoplay-declared videos.
  var opts = { passive: true, capture: true };
  ['touchstart', 'pointerdown', 'click', 'keydown'].forEach(function (ev) {
    window.addEventListener(ev, unlock, opts);
  });
})();
